import React, { useState } from 'react';
import clientImg from '../img/client.jpg'
import JointCommission from './JointCommission';
const axios = require('axios').default;

function Apply() {
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [positionDesired, setPositionDesired] = useState('');
  const [workRate, setWorkRate] = useState('Full Time');
  const [saturdayHours, setSaturdayHours] = useState('');
  const [sundayHours, setSundayHours] = useState('');
  const [mondayHours, setMondayHours] = useState('');
  const [tuesdayHours, setTuesdayHours] = useState('');
  const [wednesdayHours, setWednesdayHours] = useState('');
  const [thursdayHours, setThursdayHours] = useState('');
  const [fridayHours, setFridayHours] = useState('');
  const [social, setSocial] = useState('');
  const [isWorkEligible, setIsWorkEligible] = useState('');
  const [isPreviousEmployee, setIsPreviousEmployee] = useState('');
  const [previousEmployment, setPreviousEmployment] = useState('');
  const [otherNames, setOtherNames] = useState('');
  const [isOverSixteen, setIsOverSixteen] = useState('');
  const [hasAgeCert, setHasAgeCert] = useState('');
  const [aboutOpening, setAboutOpening] = useState('');
  const [hasBeenNurseAssist, setHasBeenNurseAssist] = useState('');
  const [registeredStates, setRegisteredStates] = useState('');
  const [hasBeenConvicted, setHasBeenConvicted] = useState('');
  const [explainConviction, setExplainConviction] = useState('');
  const [hasBeenAbusive, setHasBeenAbusive] = useState('');
  const [explainAbuse, setExplainAbuse] = useState('');
  const [hasCertAbuse, setHasCertAbuse] = useState('');
  const [hasBeenInvestigated, setHasBeenInvestigated] = useState('');
  const [highSchoolHighest, setHighSchoolHighest] = useState('');
  const [highSchoolOneName, setHighSchoolOneName] = useState('');
  const [highSchoolOneCityState, setHighSchoolOneCityState] = useState('');
  const [highSchoolOneMajorDegree, setHighSchoolOneMajorDegree] = useState('');
  const [isHighSchoolOneEnrolled, setIsHighSchoolOneEnrolled] = useState('');
  const [isHighSchoolOneGraduated, setIsHighSchoolOneGraduated] = useState('');
  const [highSchoolTwoName, setHighSchoolTwoName] = useState('');
  const [highSchoolTwoCityState, setHighSchoolTwoCityState] = useState('');
  const [highSchoolTwoMajorDegree, setHighSchoolTwoMajorDegree] = useState('');
  const [isHighSchoolTwoEnrolled, setIsHighSchoolTwoEnrolled] = useState('');
  const [isHighSchoolTwoGraduated, setIsHighSchoolTwoGraduated] = useState('');
  const [highSchoolThreeName, setHighSchoolThreeName] = useState('');
  const [highSchoolThreeCityState, setHighSchoolThreeCityState] = useState('');
  const [highSchoolThreeMajorDegree, setHighSchoolThreeMajorDegree] = useState('');
  const [isHighSchoolThreeEnrolled, setIsHighSchoolThreeEnrolled] = useState('');
  const [isHighSchoolThreeGraduated, setIsHighSchoolThreeGraduated] = useState('');
  const [collegeHighest, setCollegeHighest] = useState('');
  const [collegeOneName, setCollegeOneName] = useState('');
  const [collegeOneCityState, setCollegeOneCityState] = useState('');
  const [collegeOneMajorDegree, setCollegeOneMajorDegree] = useState('');
  const [isCollegeOneEnrolled, setIsCollegeOneEnrolled] = useState('');
  const [isCollegeOneGraduated, setIsCollegeOneGraduated] = useState('');
  const [collegeTwoName, setCollegeTwoName] = useState('');
  const [collegeTwoCityState, setCollegeTwoCityState] = useState('');
  const [collegeTwoMajorDegree, setCollegeTwoMajorDegree] = useState('');
  const [isCollegeTwoEnrolled, setIsCollegeTwoEnrolled] = useState('');
  const [isCollegeTwoGraduated, setIsCollegeTwoGraduated] = useState('');
  const [collegeThreeName, setCollegeThreeName] = useState('');
  const [collegeThreeCityState, setCollegeThreeCityState] = useState('');
  const [collegeThreeMajorDegree, setCollegeThreeMajorDegree] = useState('');
  const [isCollegeThreeEnrolled, setIsCollegeThreeEnrolled] = useState('');
  const [isCollegeThreeGraduated, setIsCollegeThreeGraduated] = useState('');
  const [vocationalHighest, setVocationalHighest] = useState('');
  const [vocationalOneName, setVocationalOneName] = useState('');
  const [vocationalOneCityState, setVocationalOneCityState] = useState('');
  const [vocationalOneMajorDegree, setVocationalOneMajorDegree] = useState('');
  const [isVocationalOneEnrolled, setIsVocationalOneEnrolled] = useState('');
  const [isVocationalOneGraduated, setIsVocationalOneGraduated] = useState('');
  const [vocationalTwoName, setVocationalTwoName] = useState('');
  const [vocationalTwoCityState, setVocationalTwoCityState] = useState('');
  const [vocationalTwoMajorDegree, setVocationalTwoMajorDegree] = useState('');
  const [isVocationalTwoEnrolled, setIsVocationalTwoEnrolled] = useState('');
  const [isVocationalTwoGraduated, setIsVocationalTwoGraduated] = useState('');
  const [vocationalThreeName, setVocationalThreeName] = useState('');
  const [vocationalThreeCityState, setVocationalThreeCityState] = useState('');
  const [vocationalThreeMajorDegree, setVocationalThreeMajorDegree] = useState('');
  const [isVocationalThreeEnrolled, setIsVocationalThreeEnrolled] = useState('');
  const [isVocationalThreeGraduated, setIsVocationalThreeGraduated] = useState('');
  const [licenseType, setLicenseType] = useState('');
  const [licenseStates, setLicenseStates] = useState('');
  const [licenseNumber, setLicenseNumber] = useState('');
  const [licenseExpiration, setLicenseExpiration] = useState('');
  const [testDate, setTestDate] = useState('');
  const [employerOneName, setEmployerOneName] = useState('');
  const [employerOneDates, setEmployerOneDates] = useState('');
  const [employerOneTitle, setEmployerOneTitle] = useState('');
  const [employerOneAddress, setEmployerOneAddress] = useState('');
  const [employerOnePhone, setEmployerOnePhone] = useState('');
  const [employerOneSup, setEmployerOneSup] = useState('');
  const [employerOneDuties, setEmployerOneDuties] = useState('');
  const [employerOneReason, setEmployerOneReason] = useState('');
  const [employerOneSalary, setEmployerOneSalary] = useState('');
  const [canContactSupEmployerOne, setCanContactSupEmployerOne] = useState('');
  const [employerTwoName, setEmployerTwoName] = useState('');
  const [employerTwoDates, setEmployerTwoDates] = useState('');
  const [employerTwoTitle, setEmployerTwoTitle] = useState('');
  const [employerTwoAddress, setEmployerTwoAddress] = useState('');
  const [employerTwoPhone, setEmployerTwoPhone] = useState('');
  const [employerTwoSup, setEmployerTwoSup] = useState('');
  const [employerTwoDuties, setEmployerTwoDuties] = useState('');
  const [employerTwoReason, setEmployerTwoReason] = useState('');
  const [employerTwoSalary, setEmployerTwoSalary] = useState('');
  const [canContactSupEmployerTwo, setCanContactSupEmployerTwo] = useState('');
  const [employerThreeName, setEmployerThreeName] = useState('');
  const [employerThreeDates, setEmployerThreeDates] = useState('');
  const [employerThreeTitle, setEmployerThreeTitle] = useState('');
  const [employerThreeAddress, setEmployerThreeAddress] = useState('');
  const [employerThreePhone, setEmployerThreePhone] = useState('');
  const [employerThreeSup, setEmployerThreeSup] = useState('');
  const [employerThreeDuties, setEmployerThreeDuties] = useState('');
  const [employerThreeReason, setEmployerThreeReason] = useState('');
  const [employerThreeSalary, setEmployerThreeSalary] = useState('');
  const [canContactSupEmployerThree, setCanContactSupEmployerThree] = useState('');
  const [referenceOneName, setReferenceOneName] = useState('');
  const [referenceOneAddress, setReferenceOneAddress] = useState('');
  const [referenceOnePhone, setReferenceOnePhone] = useState('');
  const [referenceOneAbout, setReferenceOneAbout] = useState('');
  const [referenceTwoName, setReferenceTwoName] = useState('');
  const [referenceTwoAddress, setReferenceTwoAddress] = useState('');
  const [referenceTwoPhone, setReferenceTwoPhone] = useState('');
  const [referenceTwoAbout, setReferenceTwoAbout] = useState('');
  const [relevantSkills, setRelevantSkills] = useState('');
  //
  const [success, setSuccess] = useState(false)
  const [failure, setFailure] = useState(false)
  const [validationError, setValidationError] = useState(false)
  const [validationMessage, setValidationMessage] = useState('')

  // Email address verification, do not edit.
  const isEmail = (email) => {
    const regex = /^[-_.[:alnum:]]+@((([[:alnum:]]|[[:alnum:]][[:alnum:]-]*[[:alnum:]])\.)+(ad|ae|aero|af|ag|ai|al|am|an|ao|aq|ar|arpa|as|at|au|aw|az|ba|bb|bd|be|bf|bg|bh|bi|biz|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|com|coop|cr|cs|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|edu|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gh|gi|gl|gm|gn|gov|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|in|info|int|io|iq|ir|is|it|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mil|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|museum|mv|mw|mx|my|mz|na|name|nc|ne|net|nf|ng|ni|nl|no|np|nr|nt|nu|nz|om|org|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|pro|ps|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw)$|(([0-9][0-9]?|[0-1][0-9][0-9]|[2][0-4][0-9]|[2][5][0-5])\.){3}([0-9][0-9]?|[0-1][0-9][0-9]|[2][0-4][0-9]|[2][5][0-5]))$/i;
    const isMatch = email.match(regex);
    console.log(isMatch)
    return(isMatch); // TODO: now returning null
  }

  // Copied here https://coursesweb.net/javascript/strip_tags-stripslashes-javascript_cs
  // Replaces stripslashes
  const strip_tags = (str, allow) => {
    // making sure the allow arg is a string containing only tags in lowercase (<a><b><c>)
    allow = (((allow || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
   
    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
    var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
    return str.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
    return allow.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 :'';
    });
   }

  // Submit form
  let handleSubmit = async (e) => {
    e.preventDefault();

    // Remove success or failure
    setFailure(false);
    setSuccess(false);

    // Add validation
    if(firstName.trim() === '') {
      setValidationError(true);
      setValidationMessage('Please enter your first name.');
      return;
    } else if(lastName.trim() === '') {
        setValidationError(true);
        setValidationMessage('Please enter your last name.');
        return;
    } else if(email.trim() === '') {
      setValidationError(true);
      setValidationMessage('Please enter your email address.');
      return;
    // } else if(!isEmail(email)) {
    //   setValidationError(true);
    //   setValidationMessage('You must enter a valid email address.');
    //   return;
    } else if(phone.trim() === '') {
      setValidationError(true);
      setValidationMessage('Please enter your phone number.');
      return;
    }

    // Submit request
    try {
      axios.post('/prod/apply', {
        firstName: firstName,
        middleName: middleName,
        lastName: lastName,
        email: email,
        phone: phone,
        street: street,
        city: city,
        state: state,
        zip: zip,
        positionDesired: positionDesired,
        workRate: workRate, // TODO: read from dropdown, fulltime, parttime or oncall
        saturdayHours: saturdayHours,
        sundayHours: sundayHours,
        mondayHours: mondayHours,
        tuesdayHours: tuesdayHours,
        wednesdayHours: wednesdayHours,
        thursdayHours: thursdayHours,
        fridayHours: fridayHours,
        social: social,
        isWorkEligible: isWorkEligible, // YES/NO
        isPreviousEmployee: isPreviousEmployee, // YES/NO
        previousEmployment: previousEmployment, // Optional
        otherNames: otherNames,
        isOverSixteen: isOverSixteen, // boolean
        hasAgeCert: hasAgeCert, // boolean, optional if NO above
        aboutOpening: aboutOpening,
        hasBeenNurseAssist: hasBeenNurseAssist, // boolean
        registeredStates: registeredStates, // boolean, optional if NO above
        hasBeenConvicted: hasBeenConvicted, // boolean
        explainConviction: explainConviction, // optional if NO above
        hasBeenAbusive: hasBeenAbusive, // boolean
        explainAbuse: explainAbuse, // optional if NO above
        hasCertAbuse: hasCertAbuse, // boolean
        hasBeenInvestigated: hasBeenInvestigated, // boolean
        //
        highSchoolHighest: highSchoolHighest,
        highSchoolOneName: highSchoolOneName,
        highSchoolOneCityState: highSchoolOneCityState,
        highSchoolOneMajorDegree: highSchoolOneMajorDegree,
        isHighSchoolOneEnrolled: isHighSchoolOneEnrolled, // boolean
        isHighSchoolOneGraduated: isHighSchoolOneGraduated, // boolean
        highSchoolTwoName: highSchoolTwoName,
        highSchoolTwoCityState: highSchoolTwoCityState,
        highSchoolTwoMajorDegree: highSchoolTwoMajorDegree,
        isHighSchoolTwoEnrolled: isHighSchoolTwoEnrolled, // boolean
        isHighSchoolTwoGraduated: isHighSchoolTwoGraduated, // boolean
        highSchoolThreeName: highSchoolThreeName,
        highSchoolThreeCityState: highSchoolThreeCityState,
        highSchoolThreeMajorDegree: highSchoolThreeMajorDegree,
        isHighSchoolThreeEnrolled: isHighSchoolThreeEnrolled, // boolean
        isHighSchoolThreeGraduated: isHighSchoolThreeGraduated, // boolean
        //
        collegeHighest: collegeHighest,
        collegeOneName: collegeOneName,
        collegeOneCityState: collegeOneCityState,
        collegeOneMajorDegree: collegeOneMajorDegree,
        isCollegeOneEnrolled: isCollegeOneEnrolled, // boolean
        isCollegeOneGraduated: isCollegeOneGraduated, // boolean
        collegeTwoName: collegeTwoName,
        collegeTwoCityState: collegeTwoCityState,
        collegeTwoMajorDegree: collegeTwoMajorDegree,
        isCollegeTwoEnrolled: isCollegeTwoEnrolled, // boolean
        isCollegeTwoGraduated: isCollegeTwoGraduated, // boolean
        collegeThreeName: collegeThreeName,
        collegeThreeCityState: collegeThreeCityState,
        collegeThreeMajorDegree: collegeThreeMajorDegree,
        isCollegeThreeEnrolled: isCollegeThreeEnrolled, // boolean
        isCollegeThreeGraduated: isCollegeThreeGraduated, // boolean
        //
        vocationalHighest: vocationalHighest,
        vocationalOneName: vocationalOneName,
        vocationalOneCityState: vocationalOneCityState,
        vocationalOneMajorDegree: vocationalOneMajorDegree,
        isVocationalOneEnrolled: isVocationalOneEnrolled, // boolean
        isVocationalOneGraduated: isVocationalOneGraduated, // boolean
        vocationalTwoName: vocationalTwoName,
        vocationalTwoCityState: vocationalTwoCityState,
        vocationalTwoMajorDegree: vocationalTwoMajorDegree,
        isVocationalTwoEnrolled: isVocationalTwoEnrolled, // boolean
        isVocationalTwoGraduated: isVocationalTwoGraduated, // boolean
        vocationalThreeName: vocationalThreeName,
        vocationalThreeCityState: vocationalThreeCityState,
        vocationalThreeMajorDegree: vocationalThreeMajorDegree,
        isVocationalThreeEnrolled: isVocationalThreeEnrolled, // boolean
        isVocationalThreeGraduated: isVocationalThreeGraduated, // boolean
        //
        licenseType: licenseType, // optional below based on position
        licenseStates: licenseStates,
        licenseNumber: licenseNumber,
        licenseExpiration: licenseExpiration,
        testDate: testDate, // optional (inside optional)
        //
        employerOneName: employerOneName,
        employerOneDates: employerOneDates,
        employerOneTitle: employerOneTitle,
        employerOneAddress: employerOneAddress,
        employerOnePhone: employerOnePhone,
        employerOneSup: employerOneSup,
        employerOneDuties: employerOneDuties,
        employerOneReason: employerOneReason,
        employerOneSalary: employerOneSalary,
        canContactSupEmployerOne: canContactSupEmployerOne, // boolean
        //
        employerTwoName: employerTwoName,
        employerTwoDates: employerTwoDates,
        employerTwoTitle: employerTwoTitle,
        employerTwoAddress: employerTwoAddress,
        employerTwoPhone: employerTwoPhone,
        employerTwoSup: employerTwoSup,
        employerTwoDuties: employerTwoDuties,
        employerTwoReason: employerTwoReason,
        employerTwoSalary: employerTwoSalary,
        canContactSupEmployerTwo: canContactSupEmployerTwo, // boolean
        //
        employerThreeName: employerThreeName,
        employerThreeDates: employerThreeDates,
        employerThreeTitle: employerThreeTitle,
        employerThreeAddress: employerThreeAddress,
        employerThreePhone: employerThreePhone,
        employerThreeSup: employerThreeSup,
        employerThreeDuties: employerThreeDuties,
        employerThreeReason: employerThreeReason,
        employerThreeSalary: employerThreeSalary,
        canContactSupEmployerThree: canContactSupEmployerThree, // boolean
        //
        referenceOneName: referenceOneName,
        referenceOneAddress: referenceOneAddress,
        referenceOnePhone: referenceOnePhone,
        referenceOneAbout: referenceOneAbout,
        referenceTwoName: referenceTwoName,
        referenceTwoAddress: referenceTwoAddress,
        referenceTwoPhone: referenceTwoPhone,
        referenceTwoAbout: referenceTwoAbout,
        relevantSkills: relevantSkills
      })
      .then(function (res) {
        if (res.status === 200) {
            setFirstName("");
            setMiddleName("");
            setLastName("");
            setEmail("");
            setPhone("");
            setStreet("");
            setCity("");
            setState("");
            setZip("");
            setPositionDesired("");
            setWorkRate("Full Time");
            setSaturdayHours("");
            setSundayHours("");
            setMondayHours("");
            setTuesdayHours("");
            setWednesdayHours("");
            setThursdayHours("");
            setFridayHours("");
            setSocial("");
            setIsWorkEligible("");
            setIsPreviousEmployee("");
            setPreviousEmployment("");
            setOtherNames("");
            setIsOverSixteen("");
            setHasAgeCert("");
            setAboutOpening("");
            setHasBeenNurseAssist("");
            setRegisteredStates("");
            setHasBeenConvicted("");
            setExplainConviction("");
            setHasBeenAbusive("");
            setExplainAbuse("");
            setHasCertAbuse("");
            setHasBeenInvestigated("");
            setHighSchoolHighest("");
            setHighSchoolOneName("");
            setHighSchoolOneCityState("");
            setHighSchoolOneMajorDegree("");
            setIsHighSchoolOneEnrolled("");
            setIsHighSchoolOneGraduated("");
            setHighSchoolTwoName("");
            setHighSchoolTwoCityState("");
            setHighSchoolTwoMajorDegree("");
            setIsHighSchoolTwoEnrolled("");
            setIsHighSchoolTwoGraduated("");
            setHighSchoolThreeName("");
            setHighSchoolThreeCityState("");
            setHighSchoolThreeMajorDegree("");
            setIsHighSchoolThreeEnrolled("");
            setIsHighSchoolThreeGraduated("");
            setCollegeHighest("");
            setCollegeOneName("");
            setCollegeOneCityState("");
            setCollegeOneMajorDegree("");
            setIsCollegeOneEnrolled("");
            setIsCollegeOneGraduated("");
            setCollegeTwoName("");
            setCollegeTwoCityState("");
            setCollegeTwoMajorDegree("");
            setIsCollegeTwoEnrolled("");
            setIsCollegeTwoGraduated("");
            setCollegeThreeName("");
            setCollegeThreeCityState("");
            setCollegeThreeMajorDegree("");
            setIsCollegeThreeEnrolled("");
            setIsCollegeThreeGraduated("");
            setVocationalHighest("");
            setVocationalOneName("");
            setVocationalOneCityState("");
            setVocationalOneMajorDegree("");
            setIsVocationalOneEnrolled("");
            setIsVocationalOneGraduated("");
            setVocationalTwoName("");
            setVocationalTwoCityState("");
            setVocationalTwoMajorDegree("");
            setIsVocationalTwoEnrolled("");
            setIsVocationalTwoGraduated("");
            setVocationalThreeName("");
            setVocationalThreeCityState("");
            setVocationalThreeMajorDegree("");
            setIsVocationalThreeEnrolled("");
            setIsVocationalThreeGraduated("");
            setLicenseType("");
            setLicenseStates("");
            setLicenseNumber("");
            setLicenseExpiration("");
            setTestDate("");
            setEmployerOneName("");
            setEmployerOneDates("");
            setEmployerOneTitle("");
            setEmployerOneAddress("");
            setEmployerOnePhone("");
            setEmployerOneSup("");
            setEmployerOneDuties("");
            setEmployerOneReason("");
            setEmployerOneSalary("");
            setCanContactSupEmployerOne("");
            setEmployerTwoName("");
            setEmployerTwoDates("");
            setEmployerTwoTitle("");
            setEmployerTwoAddress("");
            setEmployerTwoPhone("");
            setEmployerTwoSup("");
            setEmployerTwoDuties("");
            setEmployerTwoReason("");
            setEmployerTwoSalary("");
            setCanContactSupEmployerTwo("");
            setEmployerThreeName("");
            setEmployerThreeDates("");
            setEmployerThreeTitle("");
            setEmployerThreeAddress("");
            setEmployerThreePhone("");
            setEmployerThreeSup("");
            setEmployerThreeDuties("");
            setEmployerThreeReason("");
            setEmployerThreeSalary("");
            setCanContactSupEmployerThree("");
            setReferenceOneName("");
            setReferenceOneAddress("");
            setReferenceOnePhone("");
            setReferenceOneAbout("");
            setReferenceTwoName("");
            setReferenceTwoAddress("");
            setReferenceTwoPhone("");
            setReferenceTwoAbout("");
            setRelevantSkills("");
            setSuccess(true);
        }
      })
      .catch(function (err) {
        setFailure(true);
      });
    } catch (err) {
      setFailure(true);
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;

    switch(e.target.name) {
        // case 'comments':
        //     setComments(strip_tags(value, '<b><i><u>'))
        //     break;
        case 'firstName':
            setFirstName(value);
            break;
        case 'middleName':
            setMiddleName(value);
            break;
        case 'lastName':
            setLastName(value);
            break;
        case 'email':
            setEmail(value);
            break;
        case 'phone':
            setPhone(value);
            break;
        case 'street':
            setStreet(value);
            break;
        case 'city':
            setCity(value);
            break;
        case 'state':
            setState(value);
            break;
        case 'zip':
            setZip(value);
            break;
        case 'positionDesired':
            setPositionDesired(value);
            break;
        case 'workRate':
            setWorkRate(value);
            break;
        case 'saturdayHours':
            setSaturdayHours(value);
            break;
        case 'sundayHours':
            setSundayHours(value);
            break;
        case 'mondayHours':
            setMondayHours(value);
            break;
        case 'tuesdayHours':
            setTuesdayHours(value);
            break;
        case 'wednesdayHours':
            setWednesdayHours(value);
            break;
        case 'thursdayHours':
            setThursdayHours(value);
            break;
        case 'fridayHours':
            setFridayHours(value);
            break;
        case 'social':
            setSocial(value);
            break;
        case 'isWorkEligible':
            setIsWorkEligible(value);
            break;
        case 'isPreviousEmployee':
            setIsPreviousEmployee(value);
            break;
        case 'previousEmployment':
            setPreviousEmployment(value);
            break;
        case 'otherNames':
            setOtherNames(value);
            break;
        case 'isOverSixteen':
            setIsOverSixteen(value);
            break;
        case 'hasAgeCert':
            setHasAgeCert(value);
            break;
        case 'aboutOpening':
            setAboutOpening(value);
            break;
        case 'hasBeenNurseAssist':
            setHasBeenNurseAssist(value);
            break;
        case 'registeredStates':
            setRegisteredStates(value);
            break;
        case 'hasBeenConvicted':
            setHasBeenConvicted(value);
            break;
        case 'explainConviction':
            setExplainConviction(value);
            break;
        case 'hasBeenAbusive':
            setHasBeenAbusive(value);
            break;
        case 'explainAbuse':
            setExplainAbuse(value);
            break;
        case 'hasCertAbuse':
            setHasCertAbuse(value);
            break;
        case 'hasBeenInvestigated':
            setHasBeenInvestigated(value);
            break;
        //
        case 'highSchoolHighest':
            setHighSchoolHighest(value);
            break;
        case 'highSchoolOneName':
            setHighSchoolOneName(value);
            break;
        case 'highSchoolOneCityState':
            setHighSchoolOneCityState(value);
            break;
        case 'highSchoolOneMajorDegree':
            setHighSchoolOneMajorDegree(value);
            break;
        case 'isHighSchoolOneEnrolled':
            setIsHighSchoolOneEnrolled(value);
            break;
        case 'isHighSchoolOneGraduated':
            setIsHighSchoolOneGraduated(value);
            break;
        case 'highSchoolTwoName':
            setHighSchoolTwoName(value);
            break;
        case 'highSchoolTwoCityState':
            setHighSchoolTwoCityState(value);
            break;
        case 'highSchoolTwoMajorDegree':
            setHighSchoolTwoMajorDegree(value);
            break;
        case 'isHighSchoolTwoEnrolled':
            setIsHighSchoolTwoEnrolled(value);
            break;
        case 'isHighSchoolTwoGraduated':
            setIsHighSchoolTwoGraduated(value);
            break;
        case 'highSchoolThreeName':
            setHighSchoolThreeName(value);
            break;
        case 'highSchoolThreeCityState':
            setHighSchoolThreeCityState(value);
            break;
        case 'highSchoolThreeMajorDegree':
            setHighSchoolThreeMajorDegree(value);
            break;
        case 'isHighSchoolThreeEnrolled':
            setIsHighSchoolThreeEnrolled(value);
            break;
        case 'isHighSchoolThreeGraduated':
            setIsHighSchoolThreeGraduated(value);
            break;
        //
        case 'collegeHighest':
            setCollegeHighest(value);
            break;
        case 'collegeOneName':
            setCollegeOneName(value);
            break;
        case 'collegeOneCityState':
            setCollegeOneCityState(value);
            break;
        case 'collegeOneMajorDegree':
            setCollegeOneMajorDegree(value);
            break;
        case 'isCollegeOneEnrolled':
            setIsCollegeOneEnrolled(value);
            break;
        case 'isCollegeOneGraduated':
            setIsCollegeOneGraduated(value);
            break;
        case 'collegeTwoName':
            setCollegeTwoName(value);
            break;
        case 'collegeTwoCityState':
            setCollegeTwoCityState(value);
            break;
        case 'collegeTwoMajorDegree':
            setCollegeTwoMajorDegree(value);
            break;
        case 'isCollegeTwoEnrolled':
            setIsCollegeTwoEnrolled(value);
            break;
        case 'isCollegeTwoGraduated':
            setIsCollegeTwoGraduated(value);
            break;
        case 'collegeThreeName':
            setCollegeThreeName(value);
            break;
        case 'collegeThreeCityState':
            setCollegeThreeCityState(value);
            break;
        case 'collegeThreeMajorDegree':
            setCollegeThreeMajorDegree(value);
            break;
        case 'isCollegeThreeEnrolled':
            setIsCollegeThreeEnrolled(value);
            break;
        case 'isCollegeThreeGraduated':
            setIsCollegeThreeGraduated(value);
            break;
        //
        case 'vocationalHighest':
            setVocationalHighest(value);
            break;
        case 'vocationalOneName':
            setVocationalOneName(value);
            break;
        case 'vocationalOneCityState':
            setVocationalOneCityState(value);
            break;
        case 'vocationalOneMajorDegree':
            setVocationalOneMajorDegree(value);
            break;
        case 'isVocationalOneEnrolled':
            setIsVocationalOneEnrolled(value);
            break;
        case 'isVocationalOneGraduated':
            setIsVocationalOneGraduated(value);
            break;
        case 'vocationalTwoName':
            setVocationalTwoName(value);
            break;
        case 'vocationalTwoCityState':
            setVocationalTwoCityState(value);
            break;
        case 'vocationalTwoMajorDegree':
            setVocationalTwoMajorDegree(value);
            break;
        case 'isVocationalTwoEnrolled':
            setIsVocationalTwoEnrolled(value);
            break;
        case 'isVocationalTwoGraduated':
            setIsVocationalTwoGraduated(value);
            break;
        case 'vocationalThreeName':
            setVocationalThreeName(value);
            break;
        case 'vocationalThreeCityState':
            setVocationalThreeCityState(value);
            break;
        case 'vocationalThreeMajorDegree':
            setVocationalThreeMajorDegree(value);
            break;
        case 'isVocationalThreeEnrolled':
            setIsVocationalThreeEnrolled(value);
            break;
        case 'isVocationalThreeGraduated':
            setIsVocationalThreeGraduated(value);
            break;
        //
        case 'licenseType':
            setLicenseType(value);
            break;
        case 'licenseStates':
            setLicenseStates(value);
            break;
        case 'licenseNumber':
            setLicenseNumber(value);
            break;
        case 'licenseExpiration':
            setLicenseExpiration(value);
            break;
        case 'testDate':
            setTestDate(value);
            break;
        //
        case 'employerOneName':
            setEmployerOneName(value);
            break;
        case 'employerOneDates':
            setEmployerOneDates(value);
            break;
        case 'employerOneTitle':
            setEmployerOneTitle(value);
            break;
        case 'employerOneAddress':
            setEmployerOneAddress(value);
            break;
        case 'employerOnePhone':
            setEmployerOnePhone(value);
            break;
        case 'employerOneSup':
            setEmployerOneSup(value);
            break;
        case 'employerOneDuties':
            setEmployerOneDuties(value);
            break;
        case 'employerOneReason':
            setEmployerOneReason(value);
            break;
        case 'employerOneSalary':
            setEmployerOneSalary(value);
            break;
        case 'canContactSupEmployerOne':
            setCanContactSupEmployerOne(value);
            break;
        //
        case 'employerTwoName':
            setEmployerTwoName(value);
            break;
        case 'employerTwoDates':
            setEmployerTwoDates(value);
            break;
        case 'employerTwoTitle':
            setEmployerTwoTitle(value);
            break;
        case 'employerTwoAddress':
            setEmployerTwoAddress(value);
            break;
        case 'employerTwoPhone':
            setEmployerTwoPhone(value);
            break;
        case 'employerTwoSup':
            setEmployerTwoSup(value);
            break;
        case 'employerTwoDuties':
            setEmployerTwoDuties(value);
            break;
        case 'employerTwoReason':
            setEmployerTwoReason(value);
            break;
        case 'employerTwoSalary':
            setEmployerTwoSalary(value);
            break;
        case 'canContactSupEmployerTwo':
            setCanContactSupEmployerTwo(value);
            break;
        //
        case 'employerThreeName':
            setEmployerThreeName(value);
            break;
        case 'employerThreeDates':
            setEmployerThreeDates(value);
            break;
        case 'employerThreeTitle':
            setEmployerThreeTitle(value);
            break;
        case 'employerThreeAddress':
            setEmployerThreeAddress(value);
            break;
        case 'employerThreePhone':
            setEmployerThreePhone(value);
            break;
        case 'employerThreeSup':
            setEmployerThreeSup(value);
            break;
        case 'employerThreeDuties':
            setEmployerThreeDuties(value);
            break;
        case 'employerThreeReason':
            setEmployerThreeReason(value);
            break;
        case 'employerThreeSalary':
            setEmployerThreeSalary(value);
            break;
        case 'canContactSupEmployerThree':
            setCanContactSupEmployerThree(value);
            break;
        case 'referenceOneName':
            setReferenceOneName(value);
            break;
        case 'referenceOneAddress':
            setReferenceOneAddress(value);
            break;
        case 'referenceOnePhone':
            setReferenceOnePhone(value);
            break;
        case 'referenceOneAbout':
            setReferenceOneAbout(value);
            break;
        case 'referenceTwoName':
            setReferenceTwoName(value);
            break;
        case 'referenceTwoAddress':
            setReferenceTwoAddress(value);
            break;
        case 'referenceTwoPhone':
            setReferenceTwoPhone(value);
            break;
        case 'referenceTwoAbout':
            setReferenceTwoAbout(value);
            break;
        case 'relevantSkills':
            setRelevantSkills(value);
            break;
        default:
            // code block
    }

    // Reset validation messages
    if (success) {
      setSuccess(false);
    }
    if (failure) {
      setFailure(false);
    }
    if (validationError) {
      setValidationError(false);
      setValidationMessage('');
    }
  }

  return (
    <>
    <div className="breadcrumb-area gradient-bg bg-cover shadow dark text-light text-center" style={{backgroundImage: `url(${clientImg})`}}>
        <div className="container">
            <div className="row">
                <div className="col-lg-8 offset-lg-2">
                    <h1>Job Application</h1>
                    <ul className="breadcrumb">
                        <li><a href="/"><i className="fas fa-home"></i> Home</a></li>
                        <li className="active">Apply</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div className="blog-area single full-blog right-sidebar default-padding">
        <div className="container">
            <div className="blog-items">
                <div className="row">
                    <div className="blog-content col-lg-8 col-md-12">
                        
                        <div className="single-item">

                            <div className="blog-item-box">
                                <div className="item">
                                    <div className="info">
                                        <h4><strong>Application for Employment</strong></h4>
                                        <form onSubmit={handleSubmit} className="apply-form mt-4">

                                            {/** **/}
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="firstName" name="firstName" value={firstName} onChange={(e) => handleChange(e)} placeholder="First Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="middleName" name="middleName" value={middleName} onChange={(e) => handleChange(e)} placeholder="Middle Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="lastName" name="lastName" value={lastName} onChange={(e) => handleChange(e)} placeholder="Last Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <div className="form-group">
                                                        <input className="form-control" id="email" name="email" value={email} onChange={(e) => handleChange(e)} placeholder="Email" type="email" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="phone" name="phone" value={phone} onChange={(e) => handleChange(e)} placeholder="Phone Number" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <input className="form-control" id="street" name="street" value={street} onChange={(e) => handleChange(e)} placeholder="Street Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="city" name="city" value={city} onChange={(e) => handleChange(e)} placeholder="City" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <input className="form-control" id="state" name="state" value={state} onChange={(e) => handleChange(e)} placeholder="State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <input className="form-control" id="zip" name="zip" value={zip} onChange={(e) => handleChange(e)} placeholder="Zip" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="positionDesired" name="positionDesired" value={positionDesired} onChange={(e) => handleChange(e)} placeholder="Position Desired" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <select id="workRate" name="workRate" value={workRate} onChange={(e) => handleChange(e)}>
                                                          <option value="Full Time">Full Time</option>
                                                          <option value="Part Time">Part Time</option>
                                                          <option value="As Needed or On Call">As Needed or On Call</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* */}
                                            <div className="row mt-2">
                                                <div className="col-lg-12">
                                                    <label className="bold-text">Specify the times for each day that you are available to work:</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className='d-flex' htmlFor="saturdayHours">Saturday <input className="form-control ml-2" id="saturdayHours" name="saturdayHours" value={saturdayHours} onChange={(e) => handleChange(e)} placeholder="8:30AM - 5:30PM" type="text" /></label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className='d-flex' htmlFor="sundayHours">Sunday <input className="form-control ml-2" id="sundayHours" name="sundayHours" value={sundayHours} onChange={(e) => handleChange(e)} placeholder="8:30AM - 5:30PM" type="text" /></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className='d-flex' htmlFor="mondayHours">Monday <input className="form-control ml-2" id="mondayHours" name="mondayHours" value={mondayHours} onChange={(e) => handleChange(e)} placeholder="8:30AM - 5:30PM" type="text" /></label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className='d-flex' htmlFor="tuesdayHours">Tuesday <input className="form-control ml-2" id="tuesdayHours" name="tuesdayHours" value={tuesdayHours} onChange={(e) => handleChange(e)} placeholder="8:30AM - 5:30PM" type="text" /></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className='d-flex' htmlFor="wednesdayHours">Wednesday <input className="form-control ml-2" id="wednesdayHours" name="wednesdayHours" value={wednesdayHours} onChange={(e) => handleChange(e)} placeholder="8:30AM - 5:30PM" type="text" /></label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className='d-flex' htmlFor="thursdayHours">Thursday <input className="form-control ml-2" id="thursdayHours" name="thursdayHours" value={thursdayHours} onChange={(e) => handleChange(e)} placeholder="8:30AM - 5:30PM" type="text" /></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className='d-flex' htmlFor="fridayHours">Friday <input className="form-control ml-2" id="fridayHours" name="fridayHours" value={fridayHours} onChange={(e) => handleChange(e)} placeholder="8:30AM - 5:30PM" type="text" /></label>
                                                    </div>
                                                </div>
                                            </div>


                                            {/** **/}
                                            <div className="row mt-2">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className='d-flex' htmlFor="social"><input className="form-control" id="social" name="social" value={social} onChange={(e) => handleChange(e)} placeholder="Social Security Number" type="text" /></label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-8">
                                                    <div className="form-group">
                                                        <span className="bold-text">Are you eligible to work in the United States?</span>
                                                        <label className="ml-2" htmlFor="isWorkEligible"><input className="ml-1 align-middle" type="radio" name="isWorkEligible" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="isWorkEligible"><input className="ml-1 align-middle" type="radio" name="isWorkEligible" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <span className="bold-text">Were you previously employed by Divine Health and Staffing?</span>
                                                        <label className="ml-2" htmlFor="isPreviousEmployee"><input className="ml-1 align-middle" type="radio" name="isPreviousEmployee" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="isPreviousEmployee"><input className="ml-1 align-middle" type="radio" name="isPreviousEmployee" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                        <label className='d-flex' htmlFor="previousEmployment"><input className="form-control ml-2" id="previousEmployment" name="previousEmployment" value={previousEmployment} onChange={(e) => handleChange(e)} placeholder="If yes, when?" type="text" /></label>
                                                        <span>If you have ever been employed or attended school under another name, list other name(s) used:</span>
                                                        <label className='d-flex' htmlFor="otherNames"><input className="form-control ml-2" id="otherNames" name="otherNames" value={otherNames} onChange={(e) => handleChange(e)} placeholder="Names" type="text" /></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <span className="bold-text">Are you at least 16 years of age?*</span>
                                                        <label className="ml-2" htmlFor="isOverSixteen"><input className="ml-1 align-middle" type="radio" name="isOverSixteen" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="isOverSixteen"><input className="ml-1 align-middle" type="radio" name="isOverSixteen" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                        <span className="ml-4">If not, do you have an Employment & Age Certificate?</span>
                                                        <label className="ml-2" htmlFor="hasAgeCert"><input className="ml-1 align-middle" type="radio" name="hasAgeCert" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="hasAgeCert"><input className="ml-1 align-middle" type="radio" name="hasAgeCert" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                        <span className="ml-4">- Used only to ensure compliance with state and federal child labor laws.</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <span className="bold-text">How did you learn of this opening?</span>
                                                        <label className='d-flex' htmlFor="aboutOpening"><input className="form-control ml-2" id="aboutOpening" name="aboutOpening" value={aboutOpening} onChange={(e) => handleChange(e)} placeholder="Explain how" type="text" /></label>
                                                        <span>Have you ever performed Nurse Assistant duties or been listed on a state registry and/or licensing board:</span>
                                                        <label className="ml-2" htmlFor="hasBeenNurseAssist"><input className="ml-1 align-middle" type="radio" name="hasBeenNurseAssist" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="hasBeenNurseAssist"><input className="ml-1 align-middle" type="radio" name="hasBeenNurseAssist" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                        <label className="ml-1">If so, in order to check Abuse Registries, please list all states in which you have been registered:</label>
                                                        <label className='d-flex' htmlFor="registeredStates"><input className="form-control ml-2" id="registeredStates" name="registeredStates" value={registeredStates} onChange={(e) => handleChange(e)} placeholder="List states" type="text" /></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <span className="bold-text">Have you ever been convicted of an offense (including felonies and misdemeanors i.e. DUIs, insufficient funds, minors in consumption
and convictions removed from record), excluding minor traffic violations?*</span>
                                                        <label className="ml-2" htmlFor="hasBeenConvicted"><input className="ml-1 align-middle" type="radio" name="hasBeenConvicted" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="hasBeenConvicted"><input className="ml-1 align-middle" type="radio" name="hasBeenConvicted" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                        <textarea className="form-control" id="explainConviction" name="explainConviction" value={explainConviction} onChange={(e) => handleChange(e)} placeholder="Explain"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <span className="bold-text">Have you ever been found guilty by a court of law of abusing neglecting or mistreating a resident or of misappropriate of their
property?*</span>
                                                        <label className="ml-2" htmlFor="hasBeenAbusive"><input className="ml-1 align-middle" type="radio" name="hasBeenAbusive" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="hasBeenAbusive"><input className="ml-1 align-middle" type="radio" name="hasBeenAbusive" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                        <textarea className="form-control" id="explainAbuse" name="explainAbuse" value={explainAbuse} onChange={(e) => handleChange(e)} placeholder="Explain"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <label>* If you answered yes, include dates, places, charges, and results. Disclosure of information will
not necessarily bar you from consideration for employment and will only be considered in relation to specific job requirements. Age and
time of the offense, seriousness and nature of the violation, and rehabilitation will be taken into consideration. Under federal
regulations, however, conviction of resident abuse, neglect or mistreatment or misappropriation of resident property will disqualify you
from consideration for employment.</label>
                                                        <label className="bold-text">For anyone who has worked as a CNA:</label>
                                                        <span> Have you ever had a nurse aide registry listing or certification marked for abuse or
negligence?</span>
                                                        <label className="ml-2" htmlFor="hasCertAbuse"><input className="ml-1 align-middle" type="radio" name="hasCertAbuse" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="hasCertAbuse"><input className="ml-1 align-middle" type="radio" name="hasCertAbuse" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                        <br/>
                                                        <label className="bold-text">For anyone who has worked as a RN or LPN:</label>
                                                        <span> Have you ever been investigated by a Board of Nursing? </span>
                                                        <label className="ml-2" htmlFor="hasBeenInvestigated"><input className="ml-1 align-middle" type="radio" name="hasBeenInvestigated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="hasBeenInvestigated"><input className="ml-1 align-middle" type="radio" name="hasBeenInvestigated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                    </div>
                                                </div>
                                            </div>



                                            {/** **/}
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className="bold-text">Provide your education history. Email additional history as necessary:</label>
                                                </div>
                                            </div>
                                            <div className="row mb-2 mt-2">
                                                <div className="col-lg-8">
                                                    <label className="bold-text">High School</label>
                                                </div>
                                                <div className="col-lg-4">
                                                    <input className="form-control" id="highSchoolHighest" name="highSchoolHighest" value={highSchoolHighest} onChange={(e) => handleChange(e)} placeholder="Highest Grade Completed" type="text" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolOneName" name="highSchoolOneName" value={highSchoolOneName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolOneCityState" name="highSchoolOneCityState" value={highSchoolOneCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolOneMajorDegree" name="highSchoolOneMajorDegree" value={highSchoolOneMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isHighSchoolOneEnrolled"><input className="ml-1 align-middle" type="radio" name="isHighSchoolOneEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isHighSchoolOneEnrolled"><input className="ml-1 align-middle" type="radio" name="isHighSchoolOneEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isHighSchoolOneGraduated"><input className="ml-1 align-middle" type="radio" name="isHighSchoolOneGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isHighSchoolOneGraduated"><input className="ml-1 align-middle" type="radio" name="isHighSchoolOneGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolTwoName" name="highSchoolTwoName" value={highSchoolTwoName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolTwoCityState" name="highSchoolTwoCityState" value={highSchoolTwoCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolTwoMajorDegree" name="highSchoolTwoMajorDegree" value={highSchoolTwoMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isHighSchoolTwoEnrolled"><input className="ml-1 align-middle" type="radio" name="isHighSchoolTwoEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isHighSchoolTwoEnrolled"><input className="ml-1 align-middle" type="radio" name="isHighSchoolTwoEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isHighSchoolTwoGraduated"><input className="ml-1 align-middle" type="radio" name="isHighSchoolTwoGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isHighSchoolTwoGraduated"><input className="ml-1 align-middle" type="radio" name="isHighSchoolTwoGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolThreeName" name="highSchoolThreeName" value={highSchoolThreeName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolThreeCityState" name="highSchoolThreeCityState" value={highSchoolThreeCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="highSchoolThreeMajorDegree" name="highSchoolThreeMajorDegree" value={highSchoolThreeMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isHighSchoolThreeEnrolled"><input className="ml-1 align-middle" type="radio" name="isHighSchoolThreeEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isHighSchoolThreeEnrolled"><input className="ml-1 align-middle" type="radio" name="isHighSchoolThreeEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isHighSchoolThreeGraduated"><input className="ml-1 align-middle" type="radio" name="isHighSchoolThreeGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isHighSchoolThreeGraduated"><input className="ml-1 align-middle" type="radio" name="isHighSchoolThreeGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>


                                            <div className="row mb-2 mt-4">
                                                <div className="col-lg-8">
                                                    <label className="bold-text">College</label>
                                                </div>
                                                <div className="col-lg-4">
                                                    <input className="form-control" id="collegeHighest" name="collegeHighest" value={collegeHighest} onChange={(e) => handleChange(e)} placeholder="Highest Grade Completed" type="text" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeOneName" name="collegeOneName" value={collegeOneName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeOneCityState" name="collegeOneCityState" value={collegeOneCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeOneMajorDegree" name="collegeOneMajorDegree" value={collegeOneMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isCollegeOneEnrolled"><input className="ml-1 align-middle" type="radio" name="isCollegeOneEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isCollegeOneEnrolled"><input className="ml-1 align-middle" type="radio" name="isCollegeOneEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isCollegeOneGraduated"><input className="ml-1 align-middle" type="radio" name="isCollegeOneGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isCollegeOneGraduated"><input className="ml-1 align-middle" type="radio" name="isCollegeOneGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeTwoName" name="collegeTwoName" value={collegeTwoName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeTwoCityState" name="collegeTwoCityState" value={collegeTwoCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeTwoMajorDegree" name="collegeTwoMajorDegree" value={collegeTwoMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isCollegeTwoEnrolled"><input className="ml-1 align-middle" type="radio" name="isCollegeTwoEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isCollegeTwoEnrolled"><input className="ml-1 align-middle" type="radio" name="isCollegeTwoEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isCollegeTwoGraduated"><input className="ml-1 align-middle" type="radio" name="isCollegeTwoGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isCollegeTwoGraduated"><input className="ml-1 align-middle" type="radio" name="isCollegeTwoGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeThreeName" name="collegeThreeName" value={collegeThreeName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeThreeCityState" name="collegeThreeCityState" value={collegeThreeCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="collegeThreeMajorDegree" name="collegeThreeMajorDegree" value={collegeThreeMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isCollegeThreeEnrolled"><input className="ml-1 align-middle" type="radio" name="isCollegeThreeEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isCollegeThreeEnrolled"><input className="ml-1 align-middle" type="radio" name="isCollegeThreeEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isCollegeThreeGraduated"><input className="ml-1 align-middle" type="radio" name="isCollegeThreeGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isCollegeThreeGraduated"><input className="ml-1 align-middle" type="radio" name="isCollegeThreeGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>


                                            <div className="row mb-2 mt-4">
                                                <div className="col-lg-8">
                                                    <label className="bold-text">Vocational</label>
                                                </div>
                                                <div className="col-lg-4">
                                                    <input className="form-control" id="vocationalHighest" name="vocationalHighest" value={vocationalHighest} onChange={(e) => handleChange(e)} placeholder="Highest Grade Completed" type="text" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalOneName" name="vocationalOneName" value={vocationalOneName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalOneCityState" name="vocationalOneCityState" value={vocationalOneCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalOneMajorDegree" name="vocationalOneMajorDegree" value={vocationalOneMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isVocationalOneEnrolled"><input className="ml-1 align-middle" type="radio" name="isVocationalOneEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isVocationalOneEnrolled"><input className="ml-1 align-middle" type="radio" name="isVocationalOneEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isVocationalOneGraduated"><input className="ml-1 align-middle" type="radio" name="isVocationalOneGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isVocationalOneGraduated"><input className="ml-1 align-middle" type="radio" name="isVocationalOneGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalTwoName" name="vocationalTwoName" value={vocationalTwoName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalTwoCityState" name="vocationalTwoCityState" value={vocationalTwoCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalTwoMajorDegree" name="vocationalTwoMajorDegree" value={vocationalTwoMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isVocationalTwoEnrolled"><input className="ml-1 align-middle" type="radio" name="isVocationalTwoEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isVocationalTwoEnrolled"><input className="ml-1 align-middle" type="radio" name="isVocationalTwoEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isVocationalTwoGraduated"><input className="ml-1 align-middle" type="radio" name="isVocationalTwoGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isVocationalTwoGraduated"><input className="ml-1 align-middle" type="radio" name="isVocationalTwoGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalThreeName" name="vocationalThreeName" value={vocationalThreeName} onChange={(e) => handleChange(e)} placeholder="School Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalThreeCityState" name="vocationalThreeCityState" value={vocationalThreeCityState} onChange={(e) => handleChange(e)} placeholder="City/State" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="vocationalThreeMajorDegree" name="vocationalThreeMajorDegree" value={vocationalThreeMajorDegree} onChange={(e) => handleChange(e)} placeholder="Major or Degree" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-lg-6">
                                                    <span>Currently Enrolled?</span>
                                                    <label className="ml-2" htmlFor="isVocationalThreeEnrolled"><input className="ml-1 align-middle" type="radio" name="isVocationalThreeEnrolled" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isVocationalThreeEnrolled"><input className="ml-1 align-middle" type="radio" name="isVocationalThreeEnrolled" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span>Graduated?</span>
                                                    <label className="ml-2" htmlFor="isVocationalThreeGraduated"><input className="ml-1 align-middle" type="radio" name="isVocationalThreeGraduated" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                    <label className="ml-1" htmlFor="isVocationalThreeGraduated"><input className="ml-1 align-middle" type="radio" name="isVocationalThreeGraduated" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                </div>
                                            </div>


                                            {/** **/}
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className="bold-text">If required for this position, indicate License, Registration or Certification Information (Ex: CNA, RN, LPN, Pharmacy, etc.):</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <input className="form-control" id="licenseType" name="licenseType" value={licenseType} onChange={(e) => handleChange(e)} placeholder="Type" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <input className="form-control" id="licenseStates" name="licenseStates" value={licenseStates} onChange={(e) => handleChange(e)} placeholder="State(s)" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <input className="form-control" id="licenseNumber" name="licenseNumber" value={licenseNumber} onChange={(e) => handleChange(e)} placeholder="Number" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <input className="form-control" id="licenseExpiration" name="licenseExpiration" value={licenseExpiration} onChange={(e) => handleChange(e)} placeholder="Expiration Date" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <label>CNA’s: If still in class, please note when your test date is: </label>
                                                </div>
                                                <div className="col-lg-4">
                                                    <input className="form-control ml-2" id="testDate" name="testDate" value={testDate} onChange={(e) => handleChange(e)} placeholder="Enter test date" type="text" />
                                                </div>
                                            </div>



                                            {/** **/}
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-4">
                                                    <label className="bold-text">Beginning with your present or most recent employment (regardless of length of time), list all periods of
employment <u>and unemployment</u> including military service assignments and volunteer activities. Email
additional work history as necessary:</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className="bold-text">Most Recent Employer</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerOneName" name="employerOneName" value={employerOneName} onChange={(e) => handleChange(e)} placeholder="Company" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerOneDates" name="employerOneDates" value={employerOneDates} onChange={(e) => handleChange(e)} placeholder="Dates: (From) - (To)" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerOneTitle" name="employerOneTitle" value={employerOneTitle} onChange={(e) => handleChange(e)} placeholder="Your title" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerOneAddress" name="employerOneAddress" value={employerOneAddress} onChange={(e) => handleChange(e)} placeholder="Address: (Street) (City) (State) (Zip)" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerOnePhone" name="employerOnePhone" value={employerOnePhone} onChange={(e) => handleChange(e)} placeholder="Phone Number" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerOneSup" name="employerOneSup" value={employerOneSup} onChange={(e) => handleChange(e)} placeholder="Immediate Supervisor’s Name & Title" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <textarea className="form-control" id="employerOneDuties" name="employerOneDuties" value={employerOneDuties} onChange={(e) => handleChange(e)} placeholder="Description of Duties"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerOneReason" name="employerOneReason" value={employerOneReason} onChange={(e) => handleChange(e)} placeholder="Reason for Leaving" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerOneSalary" name="employerOneSalary" value={employerOneSalary} onChange={(e) => handleChange(e)} placeholder="Ending Salary" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group ml-2 mt-2">
                                                        <span>If currently employed, may we contact your supervisor?</span>
                                                        <label className="ml-2" htmlFor="canContactSupEmployerOne"><input className="ml-1 align-middle" type="radio" name="canContactSupEmployerOne" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="canContactSupEmployerOne"><input className="ml-1 align-middle" type="radio" name="canContactSupEmployerOne" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className="bold-text">Previous Employer</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerTwoName" name="employerTwoName" value={employerTwoName} onChange={(e) => handleChange(e)} placeholder="Company" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerTwoDates" name="employerTwoDates" value={employerTwoDates} onChange={(e) => handleChange(e)} placeholder="Dates: (From) - (To)" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerTwoTitle" name="employerTwoTitle" value={employerTwoTitle} onChange={(e) => handleChange(e)} placeholder="Your title" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerTwoAddress" name="employerTwoAddress" value={employerTwoAddress} onChange={(e) => handleChange(e)} placeholder="Address: (Street) (City) (State) (Zip)" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerTwoPhone" name="employerTwoPhone" value={employerTwoPhone} onChange={(e) => handleChange(e)} placeholder="Phone Number" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerTwoSup" name="employerTwoSup" value={employerTwoSup} onChange={(e) => handleChange(e)} placeholder="Immediate Supervisor’s Name & Title" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <textarea className="form-control" id="employerTwoDuties" name="employerTwoDuties" value={employerTwoDuties} onChange={(e) => handleChange(e)} placeholder="Description of Duties"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerTwoReason" name="employerTwoReason" value={employerTwoReason} onChange={(e) => handleChange(e)} placeholder="Reason for Leaving" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerTwoSalary" name="employerTwoSalary" value={employerTwoSalary} onChange={(e) => handleChange(e)} placeholder="Ending Salary" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group ml-2 mt-2">
                                                        <span>If currently employed, may we contact your supervisor?</span>
                                                        <label className="ml-2" htmlFor="canContactSupEmployerTwo"><input className="ml-1 align-middle" type="radio" name="canContactSupEmployerTwo" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="canContactSupEmployerTwo"><input className="ml-1 align-middle" type="radio" name="canContactSupEmployerTwo" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className="bold-text">Previous Employer</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerThreeName" name="employerThreeName" value={employerThreeName} onChange={(e) => handleChange(e)} placeholder="Company" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerThreeDates" name="employerThreeDates" value={employerThreeDates} onChange={(e) => handleChange(e)} placeholder="Dates: (From) - (To)" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerThreeTitle" name="employerThreeTitle" value={employerThreeTitle} onChange={(e) => handleChange(e)} placeholder="Your title" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerThreeAddress" name="employerThreeAddress" value={employerThreeAddress} onChange={(e) => handleChange(e)} placeholder="Address: (Street) (City) (State) (Zip)" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerThreePhone" name="employerThreePhone" value={employerThreePhone} onChange={(e) => handleChange(e)} placeholder="Phone Number" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerThreeSup" name="employerThreeSup" value={employerThreeSup} onChange={(e) => handleChange(e)} placeholder="Immediate Supervisor’s Name & Title" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <textarea className="form-control" id="employerThreeDuties" name="employerThreeDuties" value={employerThreeDuties} onChange={(e) => handleChange(e)} placeholder="Description of Duties"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerThreeReason" name="employerThreeReason" value={employerThreeReason} onChange={(e) => handleChange(e)} placeholder="Reason for Leaving" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <input className="form-control" id="employerThreeSalary" name="employerThreeSalary" value={employerThreeSalary} onChange={(e) => handleChange(e)} placeholder="Ending Salary" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group ml-2 mt-2">
                                                        <span>If currently employed, may we contact your supervisor?</span>
                                                        <label className="ml-2" htmlFor="canContactSupEmployerThree"><input className="ml-1 align-middle" type="radio" name="canContactSupEmployerThree" value="Yes" onClick={(e) => handleChange(e)} /> Yes</label>
                                                        <label className="ml-1" htmlFor="canContactSupEmployerThree"><input className="ml-1 align-middle" type="radio" name="canContactSupEmployerThree" value="No" onClick={(e) => handleChange(e)} /> No</label>
                                                    </div>
                                                </div>
                                            </div>



                                            {/** **/}
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-4">
                                                    <label className="bold-text">Give the names, addresses and phone numbers of individuals (not related to you, and not supervisors listed
above) who have knowledge of your character, experience and ability.</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className="bold-text">No. 1</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="referenceOneName" name="referenceOneName" value={referenceOneName} onChange={(e) => handleChange(e)} placeholder="Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="referenceOneAddress" name="referenceOneAddress" value={referenceOneAddress} onChange={(e) => handleChange(e)} placeholder="Address" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="referenceOnePhone" name="referenceOnePhone" value={referenceOnePhone} onChange={(e) => handleChange(e)} placeholder="Phone Number" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="referenceOneAbout" name="referenceOneAbout" value={referenceOneAbout} onChange={(e) => handleChange(e)} placeholder="How does this person know you? " type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>



                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className="bold-text">No. 2</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="referenceTwoName" name="referenceTwoName" value={referenceTwoName} onChange={(e) => handleChange(e)} placeholder="Name" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="referenceTwoAddress" name="referenceTwoAddress" value={referenceTwoAddress} onChange={(e) => handleChange(e)} placeholder="Address" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="referenceTwoPhone" name="referenceTwoPhone" value={referenceTwoPhone} onChange={(e) => handleChange(e)} placeholder="Phone Number" type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input className="form-control" id="referenceTwoAbout" name="referenceTwoAbout" value={referenceTwoAbout} onChange={(e) => handleChange(e)} placeholder="How does this person know you? " type="text" />
                                                        <span className="alert-error"></span>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className="bold-text">Relevant Skills</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mt-2">
                                                        <textarea className="form-control" id="relevantSkills" name="relevantSkills" value={relevantSkills} onChange={(e) => handleChange(e)} placeholder="Please describe any special skills/knowledge you possess that is relevant to this position"></textarea>
                                                    </div>
                                                </div>
                                            </div>


                                            {/** **/}
                                            <h6 className='mt-4'><strong>AGREEMENT:</strong></h6>
                                            <div className="row">
                                                <div className="col-lg-12 mb-2">
                                                    <label>I certify that answers given herein are true and complete to the best of my knowledge. In the event of employment,</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-2">
                                                    <label>I understand that false or misleading information given in my application or interview(s) may result in discharge.</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-2">
                                                    <label>I further understand that I am required to abide by all rules and regulations of the facility.</label>
                                                </div>
                                            </div>



                                            {/******** ********/}
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <button type="submit" name="submit" id="submit">
                                                        Send Application <i className="fa fa-paper-plane"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 alert-notification">
                                                <div id="message" className="alert-msg"></div>
                                            </div>
                                            <br />

                                            {validationError ?
                                            <div className="alert alert-error alert-warning">{validationMessage}</div> : <></>}

                                            {success ?
                                            <div className='alert alert-success'>
                                              <h3>Application Sent Successfully.</h3>
                                              <p>Thank you, your application has been submitted.</p>
                                            </div> : <></>}

                                            {failure ?
                                            <div className='alert alert-danger'>
                                              <h3>Error Sending Application.</h3>
                                              <p>An error has occured while sending your application. Please email us to resolve the issue.</p>
                                            </div> : <></>}


                                            {/** **/}
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 mt-2">
                                                    <label className='bold-text'>Divine Community Health and Staffing is an Equal Opportunity Employer.</label>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="sidebar col-lg-4 col-md-12">
                        <aside>
                            <JointCommission />
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '100px'}}>
                            </div>
                        </aside>
                    </div>

                </div>
            </div>
        </div>
    </div>

    </>
  );
}

export default Apply;